<script>
import resources from './resources'

export default {
  name: 'agendas-search-results-schedule',
  mixins: [resources]
}
</script>
<template lang="pug">
  div
    modal(
      :visible="showModal",
      :name="'agenda' + agenda.id",
      height="auto",
      @close="hideForm"
    )

      div.dialog-content
        agenda-form(
          v-if="showModal",
          :agenda="agenda",
          :schedule="currentItem",
          :time="currentTime",
          :data-covenant="currentCovenant",
          :data-patient="currentPatient",
          @scheduled="setSchedule",
          @close="hideForm()")
    table.table
      thead
        tr
          th Dia
          th
          th Hora
          th
      tbody
        tr(v-for="item in filterPeriod(agenda.schedules)", :key="item.date_id")
          th.data(v-if="parsedDayDate(item.date_id, item, filters)") {{ parsedDayDate(item.date_id, item, filters) }}

          td(v-for="(ia, i) in inWhichPeriod(item, filters)")
              a(@click.prevent="showForm(item, i, filters)")
                |{{ ia.slice(0,5) }}

        //-td(v-for="time in item.showTimes", :class="{scheduled: scheduled.includes(time.id)}")
          a(@click.prevent="showForm(item, time)")
            | {{ time.time }}
        //-td(v-if="item.showTimes.length < 3")
        //-td(v-if="item.showTimes.length < 2")
        //-td(v-if="item.showTimes.length < 1")

</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/schedule/schedule.vue